import React from "react";
import "lazysizes";
import { trackEvent } from "./src/utils/analytics";

export const wrapRootElement = ({ element }) => (
  <>
    {element}
  </>
);

export const shouldUpdateScroll = ({ routerProps }) => {
  const hash = routerProps?.location?.hash;
  if (hash) {
    const el = document.querySelector(hash);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
      return false;
    }
  }
  window.scrollTo(0, 0);
  return false;
};

// Newsletter signups are implemented six separate times in this repo — three as
// inline vanilla JS inside template files, plus download-banner.js — and two of
// the React components are dead code. They all POST to the same endpoint, so we
// listen there instead of trying to instrument each copy.
const NEWSLETTER_ENDPOINT = "/.netlify/functions/sendinblue/";

const trackNewsletterSubmits = () => {
  const originalFetch = window.fetch;
  if (typeof originalFetch !== "function") return;

  window.fetch = function (...args) {
    const result = originalFetch.apply(this, args);

    let target = "";
    try {
      const [input] = args;
      target = typeof input === "string" ? input : (input && input.url) || "";
    } catch (e) {
      return result;
    }
    if (!target.includes(NEWSLETTER_ENDPOINT)) return result;

    result
      .then((response) => {
        if (response && response.ok) {
          trackEvent("newsletter_signup", { source_page: window.location.pathname });
        }
      })
      .catch(() => {});

    return result;
  };
};

export const onClientEntry = () => {
  trackNewsletterSubmits();

  // Attribute blog -> exchange journeys: every CTA that points at the exchange
  // signup is a plain <a href>, so one delegated listener covers header, footer
  // and in-post links without touching each component.
  document.addEventListener("click", (event) => {
    const link = event.target.closest && event.target.closest("a[href]");
    if (!link) return;

    let url;
    try {
      url = new URL(link.getAttribute("href"), window.location.href);
    } catch (e) {
      return;
    }
    if (url.hostname !== "exchange.undervaluedx.com") return;

    trackEvent("cta_click", {
      cta_destination: url.pathname + url.search,
      cta_text: (link.textContent || "").trim().slice(0, 100),
      source_page: window.location.pathname,
    });
  });
};
